import { setAuthCookies, useToast } from '@foxtaibox/foxtailbox-frontend-core';
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from 'constants/cookies';
import ROUTES from 'constants/routes';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const useHandleLogin = () => {
  const navigate = useNavigate();
  const { showErrorToast } = useToast();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const searchObject = Object.fromEntries(searchParams);
  const { redirectUrl } = searchObject;

  return (accessToken?: string, refreshToken?: string) => {
    if (accessToken && refreshToken) {
      const newCookies = [
        { name: ACCESS_TOKEN_NAME, value: accessToken },
        { name: REFRESH_TOKEN_NAME, value: refreshToken },
      ];

      setAuthCookies(newCookies);

      if (redirectUrl) {
        const decodedRedirectUrl = decodeURIComponent(redirectUrl);

        try {
          const targetUrl = new URL(decodedRedirectUrl, window.location.origin);
          if (targetUrl.origin === window.location.origin) {
            const { pathname, search, hash } = targetUrl;

            navigate({ pathname, search, hash }, { replace: true });
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('Ошибка navigate redirectUrl', error);
        }
      } else {
        navigate(ROUTES.LANGUAGE_SELECT);
      }
    } else {
      showErrorToast(t('errors.common'));
      // eslint-disable-next-line no-console
      console.error('нет токенов');
    }
  };
};

export default useHandleLogin;
